/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';

const StickyButtonMobile = () => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="sticky-button-mobile" id="stick-button-mobile" xmlnsXlink="http://www.w3.org/1999/xlink" width="383.57" height="126.97" viewBox="0 0 383.57 126.97">
            <defs>
            <filter id="Rectangle_1" x="0" y="0" width="383.57" height="126.97" filterUnits="userSpaceOnUse">
                <feOffset input="SourceAlpha"/>
                <feGaussianBlur stdDeviation="15" result="blur"/>
                <feFlood floodOpacity="0.502"/>
                <feComposite operator="in" in2="blur"/>
                <feComposite in="SourceGraphic"/>
            </filter>
            </defs>
            <g id="Group_4" dataName="Group 4" transform="translate(-2246 -671)">
            <g id="Group_3" dataName="Group 3">
                <g transform="matrix(1, 0, 0, 1, 2246, 671)" filter="url(#Rectangle_1)">
                <rect id="Rectangle_1-2" dataName="Rectangle 1" width="293.57" height="36.97" rx="18.485" transform="translate(45 45)" fill="#74a950"/>
                </g>
                <path id="Path_1" dataName="Path 1" d="M205.831,20.926H189.99m9.387,6.406,6.459-6.406-6.459-6.406" transform="translate(2363.264 713.559)" fill="none" stroke="#fff" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2"/>
            </g>
            </g>
      </svg>
      
    );
}

export default StickyButtonMobile;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/stickyButtonMobile.jsx